import { WorkingHoursDeletePayload, WorkingHoursPutPayload } from "app/models/user"
import WorkingHour from "app/models/workingHour"

export enum Types {
  GET = "PREFERED_HOURS_GET",
  GET_SUCCESS = "PREFERED_HOURS_GET_SUCCESS",
  GET_FAIL = "PREFERED_HOURS_GET_FAIL",
  PUT = "PREFERED_HOURS_PUT",
  PUT_SUCCESS = "PREFERED_HOURS_PUT_SUCCESS",
  PUT_FAIL = "PREFERED_HOURS_PUT_FAIL",
  DELETE = "PREFERED_HOURS_DELETE",
  DELETE_SUCCESS = "PREFERED_HOURS_DELETE_SUCCESS",
  DELETE_FAIL = "PREFERED_HOURS_DELETE_FAIL",
}

export type Action =
  | GetPreferedHoursAction
  | GetPreferedHoursSuccessAction
  | GetPreferedHoursFailAction
  | PutPreferedHoursAction
  | PutPreferedHoursSuccessAction
  | PutPreferedHoursFailAction
  | DeletePreferedHoursAction
  | DeletePreferedHoursSuccessAction
  | DeletePreferedHoursFailAction

export type GetPreferedHoursAction = {
  payload: { id: string }
  type: Types.GET
}

export type GetPreferedHoursSuccessAction = {
  payload: { data: WorkingHour[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetPreferedHoursFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PutPreferedHoursAction = {
  type: Types.PUT
  payload: WorkingHoursPutPayload
}

export type PutPreferedHoursSuccessAction = {
  type: Types.PUT_SUCCESS
  payload: { data: WorkingHour[] | undefined }
}

export type PutPreferedHoursFailAction = {
  type: Types.PUT_FAIL
  payload: { errors: object }
}

export type DeletePreferedHoursAction = {
  type: Types.DELETE
  payload: WorkingHoursDeletePayload
}

export type DeletePreferedHoursSuccessAction = {
  type: Types.DELETE_SUCCESS
  payload: { data: WorkingHour[] | undefined }
}

export type DeletePreferedHoursFailAction = {
  type: Types.DELETE_FAIL
  payload: { errors: object }
}

export function getPreferedHours(id: string): GetPreferedHoursAction {
  return {
    payload: { id },
    type: Types.GET,
  }
}

export function getPreferedHoursSuccess(data: WorkingHour[] | undefined): GetPreferedHoursSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getPreferedHoursFail(errors: object): GetPreferedHoursFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function putPreferedHours(payload: WorkingHoursPutPayload): PutPreferedHoursAction {
  return {
    payload,
    type: Types.PUT,
  }
}

export function putPreferedHoursSuccess(data: WorkingHour[] | undefined): PutPreferedHoursSuccessAction {
  return {
    payload: { data },
    type: Types.PUT_SUCCESS,
  }
}

export function putPreferedHoursFail(errors: object): PutPreferedHoursFailAction {
  return {
    payload: { errors },
    type: Types.PUT_FAIL,
  }
}

export function deletePreferedHours(payload: WorkingHoursDeletePayload): DeletePreferedHoursAction {
  return {
    payload,
    type: Types.DELETE,
  }
}

export function deletePreferedHoursSuccess(data: WorkingHour[] | undefined): DeletePreferedHoursSuccessAction {
  return {
    payload: { data },
    type: Types.DELETE_SUCCESS,
  }
}

export function deletePreferedHoursFail(errors: object): DeletePreferedHoursFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}
